import MultiselectDropdownRedesign, {
  MultiSelectOption,
} from 'components/MultiSelectDropdown/MultiSelectDropdownRedesign';
import Labels from 'components/UsersPermissions/UserPermissionsForm/Labels';
import { selectableUserTypes, selectableUserTypesSimple, UserType } from 'constants/userRoles';
import { startCase } from 'lodash';
import React, { useState } from 'react';
import { getUser } from 'selectors/auth';
import { useSelector } from 'store';
import { Role } from 'types';
import { userRolesToTypes, userTypesToRoles } from 'utils/userRoles';

type ComponentProps = {
  className?: string;
  selectedRoles: string[];
  onChange: (roles: string[]) => void;
  title?: string;
  showLabels?: boolean;
  useSimpleRoles?: boolean;
};

const UserTypesSelect: React.FC<ComponentProps> = (props) => {
  const { className, onChange, selectedRoles, title, showLabels, useSimpleRoles = false } = props;

  const user = useSelector(getUser);
  const isSuperAdmin = user.roles.includes('super-admin');

  const [selectedTypes, setSelectedTypes] = useState<UserType['label'][]>(
    userRolesToTypes(selectedRoles as Role[], useSimpleRoles).map((t) => t.label)
  );

  const userTypes = useSimpleRoles ? selectableUserTypesSimple : selectableUserTypes;

  const options = Object.values(userTypes)
    .filter((r) => r.label !== 'Litlingo Admin' || isSuperAdmin)
    .map((r) => r.label);

  const handleChange = (option: MultiSelectOption): void => {
    const isSelected = selectedTypes.includes(option.value);

    if (isSelected) {
      onChange(
        userTypesToRoles(
          selectedTypes.filter((t) => t !== option.value),
          useSimpleRoles
        ) as string[]
      );
      setSelectedTypes((types) => types.filter((t) => t !== option.value));
    } else {
      onChange(userTypesToRoles([...selectedTypes, option.value], useSimpleRoles) as string[]);
      setSelectedTypes((types) => [...types, option.value]);
    }
  };

  const handleDelete = (option: MultiSelectOption): void => {
    const isSelected = selectedTypes.includes(option.value);

    if (isSelected) {
      onChange(
        userTypesToRoles(
          selectedTypes.filter((t) => t !== option.value),
          useSimpleRoles
        ) as string[]
      );
      setSelectedTypes((types) => types.filter((t) => t !== option.value));
    }
  };

  return (
    <div className="flex flex-row gap-2">
      <div className="min-w-42 w-42">
        <MultiselectDropdownRedesign
          className={className || ''}
          placeholder={title}
          onChange={handleChange}
          options={options.map((o) => ({ value: o, label: startCase(o) }))}
          selectedItems={selectedTypes.map((i) => ({ value: i, label: startCase(i) }))}
          dataTestid="active"
        />
      </div>
      {showLabels && (
        <Labels
          includedLabels={selectedRoles.map((i) => ({ value: i, label: i }))}
          handleDelete={handleDelete}
        />
      )}
    </div>
  );
};

export default UserTypesSelect;
